import React from "react";
import Modal from "_c/Modals";
import Loadable from "./loadable";
import type { tSaloonMasterProfileViewerProps } from "./types";

const SaloonMasterProfileModal = (props: tSaloonMasterProfileViewerProps) => {
  return (
    <Modal
      onClose={props.onClose}
      isOpen={Boolean(
        props.isOpen && props.saloonId && props.employeeId && props.kind,
      )}
    >
      <Loadable {...props} />
    </Modal>
  );
};
export default SaloonMasterProfileModal;
